import { z } from 'zod';

/**
 * Validation schema for the tag create/edit form.
 *
 * @remarks
 * Error strings are i18n keys (e.g. `'tags.form.validation.nameRequired'`),
 * not user-facing messages — the Zod error map resolves them via i18next at runtime.
 */
export const tagFormSchema = z.object({
  name: z
    .string()
    .min(1, { error: 'tags.form.validation.nameRequired' })
    .max(100, { error: 'tags.form.validation.nameTooLong' }),
  color: z.string().min(1, { error: 'tags.form.validation.colorRequired' }),
});

export type TagFormValues = z.infer<typeof tagFormSchema>;
